import { RedButton } from "@clockwise/web-commons/src/ui/red-button";
import { graphql } from "react-relay";

/////////
// GQL //
/////////

export const fragments = {
  user: graphql`
    fragment OnboardingFlexMeetingStepRenderer_user on User {
      id
      emails
    }
  `,
  org: graphql`
    fragment OnboardingFlexMeetingStepRenderer_org on Org
    @argumentDefinitions(timeZone: { type: "String!" }) {
      id
      experiments
      primaryOrgCalendar
      ...OnboardingAutopilotEvent_org
      autopilotEventsResponse(timeZone: $timeZone) {
        __typename
        ... on AutopilotEventsResponse {
          suggestedOrganized {
            ...OnboardingAutopilotEvent_event
            calendarIds
            title
            annotatedEvent {
              externalEventId
              id
              userTags {
                tag
                states {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
              orgTags {
                tag
                state {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
            }
            recurringEventId
            recurrenceRules {
              interval {
                interval
                freqType
              }
            }
            annotatedRecurringEvent {
              id
              userTags {
                tag
                states {
                  value
                  subjectType
                  subjectValue
                  lastModified
                  active
                }
              }
              orgTags {
                tag
                state {
                  active
                  value
                  subjectType
                  subjectValue
                  lastModified
                }
              }
            }
            createdMillis
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
            }
            attendees {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
            suggestedAutopilotSettingsResponseV3 {
              __typename
              ... on SuggestedAutopilotSettingsResponseV3 {
                intersectionOfAttendeesMeetingHours {
                  minSlot {
                    dayOffset
                    timeSlot
                  }
                  maxSlot {
                    dayOffset
                    timeSlot
                  }
                }
                calendarIdToMeetingHours {
                  calendarId
                  dayOffsetTimeSlotRanges {
                    minSlot {
                      dayOffset
                      timeSlot
                    }
                    maxSlot {
                      dayOffset
                      timeSlot
                    }
                  }
                }
                suggestedAutopilotSettings {
                  isRoomFlexible
                  movementType
                  allowedEndTime {
                    dayOffset
                    timeSlot
                  }
                  allowedStartTime {
                    dayOffset
                    timeSlot
                  }
                }
              }
              ... on GraphEntityError {
                message
              }
            }
            moveRangeInLocalTimeV3 {
              __typename
              ... on MoveRangeInLocalTimeV3 {
                allowedStartTimeInclusive {
                  dayOffset
                  timeSlot
                }
                allowedEndTimeInclusive {
                  dayOffset
                  timeSlot
                }
              }
              ... on GraphEntityError {
                message
              }
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};

export const canAutopilotQuery = graphql`
  query OnboardingFlexMeetingStepRendererQuery(
    $orgRelayId: ID!
    $externalEventIds: [String!]!
    $userCalendarIds: [String!]!
  ) {
    org: node(id: $orgRelayId) {
      ... on Org {
        canScheduleResponse(externalEventIds: $externalEventIds, calendarIds: $userCalendarIds) {
          __typename
          ... on CanScheduleResponseList {
            list {
              externalEventId
              canAutopilot
              attendeeNotInDomain
              organizerNotClockwiseUser
              isAllDayEvent
            }
          }
        }
      }
    }
  }
`;
